<template>
  <div>
    <v-dialog
      v-if="$store.state.selectedMapObject && $store.state.selectedMapObject"
      v-model="$store.state.mapObjectDialog"
      width="297"
      overlay-color="white"
      :overlay-opacity="isMobileView ? '0.8' : '0.5'"
      content-class="elevation-0 ma-0 pa-0 text-center"
    >
      <ListObject
        class="elevation-3 text-left"
        :dialog-view="true"
        :object="$store.state.selectedMapObject"
      />
      <v-btn
        fab
        dark
        small
        class="csr-btn-color mt-4 mb-2 elevation-2"
        @click="$store.state.mapObjectDialog = false"
      >
        <v-icon large>close</v-icon>
      </v-btn>
    </v-dialog>
    <div
      id="list-map"
      :style="{
        width: '100%',
        height: height + 'px',
        overflow: 'hidden',
        borderRadius: '8px',
      }"
    />
  </div>
</template>

<script>
import ListObject from '@/components/List/ListObject/ListObject.vue'
import sharedComputed from '@/methods/sharedComputed'

let CustomOverlay

function initializeCustomOverlayClass() {
  CustomOverlay = class CustomOverlay extends google.maps.OverlayView {
    constructor(position, content, map) {
      super()
      this.position = position
      this.content = content
      this.map = map
      this.setMap(map)
    }

    draw() {
      const projection = this.getProjection()
      const position = projection.fromLatLngToDivPixel(this.position)

      // Adjust the left position to horizontally center the priceDiv
      this.content.style.left = position.x - this.content.offsetWidth / 2 + 'px'

      this.content.style.top = position.y + 10 + 'px'

      this.content.style.position = 'absolute'
      this.content.style.pointerEvents = 'auto' // Enable pointer events on the price element

      this.getPanes().floatPane.appendChild(this.content)
    }
  }
}

export default {
  name: 'ListMap',
  components: { ListObject },

  data() {
    return {
      openInfoWindow: null,
      showMap: false,
    }
  },

  props: {
    height: {
      type: Number,
      default: 400,
    },
    mapCoords: {
      type: Object,
      default: () => {
        return {
          lat: 36.486472,
          lng: -5.016985,
        }
      },
    },
  },

  created() {
    initializeCustomOverlayClass()
    this.$nextTick(() => {
      this.initMap()
    })
  },

  computed: {
    ...sharedComputed,
    mapAddresses() {
      return (this.$store.state.searchMapResult || [])
        .map((object) => {
          const tmp = object.mapCoords && object.mapCoords.split(',')
          const location =
            tmp && tmp[0] && tmp[1]
              ? {
                  lat: parseFloat(tmp[0].trim()),
                  lng: parseFloat(tmp[1].trim()),
                }
              : {}

          // Calculate display price using same logic as ObjectPrice.vue
          let displayPrice = object.dayPrice
          if (object.bookingPrice) {
            if (parseInt(object.bookingDays) >= 26) {
              // Show monthly price for bookings 26+ days
              const monthDays = object.bookingDays < 30 ? object.bookingDays : 30
              displayPrice = Math.round(
                (object.bookingPrice / parseInt(object.bookingDays)) * monthDays
              )
            } else {
              // Show total booking price for shorter stays
              displayPrice = object.bookingPrice
            }
          }

          return {
            location,
            bookingPrice: object.bookingPrice,
            dayPrice: object.dayPrice,
            displayPrice: displayPrice,
            bookingDays: object.bookingDays,
            name: object.objectName,
            objectName: object.objectName,
            mapCoords: object.mapCoords,
            data: object,
          }
        })
        .filter((o) => !!o.dayPrice || !!o.bookingPrice)
    },
  },

  methods: {
    initMap() {
      let location = this.mapCoords
      google.maps.visualRefresh = false
      let map = new google.maps.Map(document.getElementById('list-map'), {
        // zoom: 12,
        // center: location,
        // disableDefaultUI: true,
        clickableIcons: false,
        mapTypeControlOptions: {
          mapTypeIds: [],
        },
        fullscreenControl: false,
        streetViewControl: false,
        gestureHandling: this.isMobileView ? 'greedy' : 'cooperative',
        // gestureHandling: 'cooperative',
      })
      // let marker = new google.maps.Marker({ position: location, map: map })

      const villas = this.mapAddresses
      const bounds = new google.maps.LatLngBounds()

      villas.forEach((villa) => {
        const smallMarker = new google.maps.Marker({
          position: villa.location,
          map: map,
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 5, // Adjust the scale as needed
            fillColor: 'rgb(33, 155, 200)', // Change the color as needed
            fillOpacity: 1,
            strokeWeight: 0,
          },
        })

        bounds.extend(villa.location)

        // Create a custom HTML element for the price
        const priceDiv = document.createElement('div')
        priceDiv.className = 'price-label'
        priceDiv.innerHTML =
          '<div class="map-day-price">' +
          villa.displayPrice +
          ' €</div>'

        // Add the price element to the map at the specified coordinates
        const priceLabel = new CustomOverlay(villa.location, priceDiv, map)

        // console.log('priceLabel position:', priceLabel.getPosition())

        // Add a click event listener to show additional details if needed
        priceDiv.addEventListener('click', (e) => {
          console.log(e, 4777)
          e.preventDefault()
          e.stopPropagation()
          console.log('Click event triggered', e)
          this.$store.state.selectedMapObject = villa.data
          this.$store.state.mapObjectDialog = true
          // const infoWindowContent = `<div><strong>${
          //   villa.name
          // }</strong><br>Price: ${villa.bookingPrice || villa.dayPrice} € ${
          //   villa.bookingPrice ? '' : ' / ' + this.$i18n.t('öö').toLowerCase()
          // }</div>`
          // console.log('InfoWindow content:', infoWindowContent)

          // if (this.openInfoWindow) {
          //   this.openInfoWindow.close()
          // }
          //
          // const infoWindow = new google.maps.InfoWindow({
          //   content: infoWindowContent,
          // })
          // infoWindow.setPosition(villa.location)
          // infoWindow.setZIndex(1000)
          // infoWindow.open(map, priceLabel)
          // this.openInfoWindow = infoWindow
          // infoWindow.open(map)
          return false
        })
      })

      map.fitBounds(bounds)
    },
  },
}
</script>

<style>
.map-day-price {
  border: 1px solid white;
  background: #ffcb01;
  padding: 2px 4px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
}
</style>
